"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactAria = require("react-aria");
var _InfoDisplayWrapper = require("../../../shared/utility-components/InfoDisplayWrapper");
var _FocusRing = require("../../../shared/utility-components/FocusRing");
var _input = require("../../../components/inputs/input/input.tokens");
var _globalTokens = require("../../../shared/global-tokens");
var _input2 = require("./input.tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var Input = _styledComponents.default.textarea.withConfig({
  displayName: "TextArea__Input",
  componentId: "sc-3yut8o-0"
})(["display:flex;align-items:center;height:", ";width:", ";padding:", " ", ";background-color:", ";border:", ";border-radius:", ";", ";-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;outline:none;resize:none;color:", ";", " ", " ::placeholder{color:", ";", ";}"], function (_ref) {
  var height = _ref.height;
  return "".concat(height, "px");
}, function (_ref2) {
  var width = _ref2.width;
  return _input.tokens.size.width[width];
}, _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['400'], _input.tokens.color.background.default, _input.tokens.border.default, _input.tokens.borderRadius, _tokens.default.sky.sys.font.body['1'], _globalTokens.globalColor.text.content.main, function (_ref3) {
  var error = _ref3.error;
  return error && (0, _styledComponents.css)(["border:", ";"], _input.tokens.border.error);
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && (0, _styledComponents.css)(["pointer-events:none;background-color:", ";border:", ";"], _input.tokens.color.background.disabled, _input.tokens.border.disabled);
}, _globalTokens.globalColor.text.content.auxiliary, _tokens.default.sky.sys.font.body['1']);
var TextArea = /*#__PURE__*/_react.default.forwardRef(function (_ref5, ref) {
  var value = _ref5.value,
    defaultValue = _ref5.defaultValue,
    isOptional = _ref5.isOptional,
    _ref5$height = _ref5.height,
    height = _ref5$height === void 0 ? 80 : _ref5$height,
    _ref5$width = _ref5.width,
    width = _ref5$width === void 0 ? _input2.TextFieldWidth.FLEX : _ref5$width,
    placeholder = _ref5.placeholder,
    label = _ref5.label,
    disabled = _ref5.disabled,
    errorMessage = _ref5.errorText,
    description = _ref5.helperText,
    dataCy = _ref5['data-cy'],
    dataUserpilot = _ref5['data-userpilot'],
    onChange = _ref5.onChange,
    onBlur = _ref5.onBlur,
    maxLength = _ref5.maxLength;
  var localRef = _react.default.useRef(null);
  var inputRef = ref || localRef;
  var _ref6 = (0, _reactAria.useTextField)({
      value: value,
      onChange: onChange,
      label: label,
      inputElementType: 'textarea',
      isRequired: !isOptional,
      placeholder: placeholder,
      isDisabled: disabled,
      errorMessage: errorMessage,
      description: description,
      defaultValue: defaultValue,
      maxLength: maxLength
    }, inputRef),
    labelProps = _ref6.labelProps,
    inputProps = _ref6.inputProps,
    descriptionProps = _ref6.descriptionProps,
    errorMessageProps = _ref6.errorMessageProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InfoDisplayWrapper.InfoDisplayWrapper, {
    label: label,
    ariaLabelProps: labelProps,
    isOptional: isOptional,
    helperText: description,
    ariaHelpTextProps: descriptionProps,
    errorText: errorMessage,
    ariaErrorTextProps: errorMessageProps,
    "data-cy": dataCy,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FocusRing.FocusRing, {
      isTextInput: true,
      mouseFocus: true,
      isFlex: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Input, _objectSpread({}, inputProps, {
        height: height,
        width: width,
        error: !!errorMessage,
        "data-cy": dataCy,
        "data-userpilot": dataUserpilot,
        ref: inputRef,
        onBlur: onBlur
      }))
    })
  });
});
TextArea.defaultProps = {
  placeholder: '',
  label: '',
  isOptional: false,
  disabled: false,
  errorText: '',
  helperText: '',
  onChange: function onChange(e) {
    return e.target.value;
  },
  onBlur: function onBlur(e) {
    return e.target.value;
  }
};
var TextAreaNamespace = Object.assign(TextArea, {
  WIDTH: _input2.TextFieldWidth
});
var _default = exports.default = TextAreaNamespace;